var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.position === 'asc')?_c('Down'):(_vm.position === 'desc')?_c('Up'):_c('Ordenate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }